import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./util/rem";

import { Swipe, SwipeItem, Area, Popup, Toast, List, ImagePreview } from "vant";

Vue.use(Swipe)
  .use(SwipeItem)
  .use(Popup)
  .use(Toast)
  .use(List)
  .use(ImagePreview)
  .use(Area);

Vue.prototype.$Toast = Toast;
Vue.prototype.$ImagePreview = ImagePreview;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
